import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import api from '../services/api';
import { useAuth } from './AuthContext';

const ProductKlasseContext = createContext({
  map: {},
  loading: false,
  refresh: async () => {},
});

export function ProductKlasseProvider({ children }) {
  const { user } = useAuth();
  const [map, setMap] = useState({});
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) {
      setMap({});
      return;
    }
    setLoading(true);
    try {
      const response = await api.get('/producten/product-klasse-map');
      setMap(response.data || {});
    } catch (err) {
      console.error('[ProductKlasse] laden mislukt:', err);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <ProductKlasseContext.Provider value={{ map, loading, refresh }}>
      {children}
    </ProductKlasseContext.Provider>
  );
}

export function useProductKlasse() {
  return useContext(ProductKlasseContext);
}
